var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 102.15 93.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fdd911;}.cls-3{fill:#2b2c2b;}.cls-2{filter:url(#drop-shadow-1);}"), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.57,
    dy: 1.78
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#010101",
    floodOpacity: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exclamation_mark_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.69,23.66c1.06-1.84,3.02-2.97,5.15-2.97s4.09,1.13,5.15,2.97l28.93,50.11c1.06,1.84,1.06,4.1,0,5.94-1.06,1.84-3.02,2.97-5.15,2.97H17.91c-2.12,0-4.09-1.13-5.15-2.97s-1.06-4.1,0-5.94L41.69,23.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.91,79.71c-1.07,0-2.03-.56-2.57-1.49-.54-.93-.54-2.04,0-2.97L44.27,25.14c.54-.93,1.5-1.48,2.57-1.48s2.04,.55,2.57,1.48l28.93,50.11c.54,.93,.53,2.04,0,2.97-.54,.93-1.5,1.49-2.57,1.49H17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.91,77.33c-.31,0-.46-.21-.51-.3-.06-.11-.15-.33,0-.59L46.33,26.33c.15-.27,.41-.3,.51-.3s.36,.03,.51,.3l28.93,50.11c.15,.27,.05,.5,0,.59-.05,.09-.21,.3-.51,.3H17.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Exclamation_mark",
    className: "cls-3",
    d: "M49.81,70.2c0,1.64-1,2.97-2.97,2.97s-2.97-1.33-2.97-2.97,1-2.97,2.97-2.97,2.97,1.33,2.97,2.97Zm-2.97-32.09c-2.93,0-4.43,2.15-4.12,4.79h0l2.36,19.85h0c.1,.86,.69,1.51,1.76,1.51s1.66-.66,1.76-1.51h0l2.36-19.85h0c.31-2.63-1.18-4.79-4.12-4.79Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.b3645ceb9725eb30283fb9c53b1d9ddd.svg";
export { ForwardRef as ReactComponent };